import * as React from "react";
import {colors} from "@unibuddy/patron";
import {IconThumbDown} from "../../icons";
import {FeedbackButtonWrapper} from "./FeedbackButtonWrapper";

export type DislikeButtonProps = {
    isDisliked: boolean;
    onClick(): void | Promise<void>;
};

export const DislikeButton = React.memo(({isDisliked, onClick}: DislikeButtonProps) => (
    <FeedbackButtonWrapper
        isActive={isDisliked}
        fillColor={colors.red300}
        onClick={onClick}
        aria-label="Dislike"
        ghost
    >
        <IconThumbDown color={colors.grey700} height={14} />
    </FeedbackButtonWrapper>
));
DislikeButton.displayName = "DislikeButton";
